import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: "/methods/:email",
    name: "Methods",
    component: () => import('../views/MethodsView.vue'),
    props: true
  },
  {
    path: "/card/:email",
    name: "Card",
    component: () => import('../views/CardView.vue'),
    props: true
  },
  {
    path: '/pending',
    name: 'Pending',
    component: () => import('../views/PendingView.vue')
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('../views/SuccessView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
